import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { 
  ChartBarIcon, 
  UserGroupIcon, 
  ClipboardDocumentListIcon 
} from '@heroicons/react/24/outline';

const ActivityStream = ({ activities = [] }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'valuation':
        return <ChartBarIcon className="h-5 w-5 text-succession-primary transition-theme" />;
      case 'deal':
        return <UserGroupIcon className="h-5 w-5 text-succession-success transition-theme" />;
      case 'listing':
        return <ClipboardDocumentListIcon className="h-5 w-5 text-succession-secondary transition-theme" />;
      default:
        return null;
    }
  };

  if (!Array.isArray(activities)) {
    console.error('Activities prop must be an array');
    return null;
  }

  return (
    <div className="bg-succession-bg-primary shadow-succession-md rounded-lg border border-succession-border transition-theme">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg font-medium text-succession-text-primary transition-theme"><FormattedMessage id="succession.activity_stream.recent_activity" /></h3>
      </div>
      <div className="border-t border-succession-border">
        <ul className="divide-y divide-succession-border">
          {activities.map((activity) => (
            <li key={activity.id} className="px-4 py-4 sm:px-6">
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  {getActivityIcon(activity.type)}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-succession-text-primary truncate transition-theme">
                    {activity.content}
                  </p>
                  <p className="text-sm text-succession-text-secondary transition-theme">
                    {activity.timestamp}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

ActivityStream.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      type: PropTypes.oneOf(['valuation', 'deal', 'listing']).isRequired,
      content: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
    })
  )
};

ActivityStream.defaultProps = {
  activities: []
};

export default ActivityStream; 